import React, { lazy, Suspense, useEffect, useState } from "react";
import {
  Navigate,
  useLocation,
  Route,
  Routes,
  useSearchParams,
} from "react-router-dom";
import { Loader } from "semantic-ui-react";

import store from "reduxStore";
import { setUser,setCurrencies, setStyles ,setTranByRedux,setMerchantInfoByRedux, setTemplateByRedux} from "reduxStore/actions";

import {
  getClientByEmail,
  getMerchantByEmail,
  getStoreByEmail,
  getCampaignByUid,
  campaignApi,
  updateClient,
  getTemplate,
  getCurrencies,
} from "api/paymentManagement/restfulApi";

import { app } from "service/firebase/init";

import { isDev } from "constant";
import Loading from "components/loading";
import dayjs from "dayjs";
import {default_white} from "constant/templates"

console.log("yoooooo is dev?", isDev);

const auth = app.auth();

const HtmlRender = lazy(() => import("page/htmlRender"));
const TestBarcode = lazy(() => import("page/testBarcode"));
const FpsScanner = lazy(() => import("page/fps-scanner/fpsScanner"));
const Login = lazy(() => import("page/login/login"));
const ResetPassword = lazy(() => import("page/login/resetPassword"));
const LandingPage = lazy(() => import("page/landing-page/landingPage"));
const LoginPaymentSucess = lazy(() => import("page/loginPaymentSuccess"));
const PrintReceipt = lazy(() => import("components/printReceipt"));
const NewOrderPrint = lazy(() => import("../components/printReceipt"));
const PaymentSuccessful = lazy(() =>
  import("page/webStore/remote/paymentSuccessful")
);
const Index = lazy(() => import("page/webStore/main"));
const Moono = lazy(() => import("page/webStore/moono/moono"));

const Transaction = lazy(() => import("page/transaction/transaction"));
const Quotation = lazy(() => import("page/transaction/quotation"));
const Feedback = lazy(() => import("page/transaction/feedback"));
const StripePayment = lazy(() => import("page/payment/stripePayment"));
const MastercardPayment = lazy(() => import("page/payment/mastercardPayment"));
const VisaPayment = lazy(() => import("page/payment/visaPayment"));
const FpsBankInPayment = lazy(() => import("page/payment/fpsBankInPayment"));
const FpsAcquirerDynamicPayment = lazy(() => import("page/payment/fpsAcquirerDynamicPayment"));
const BankInPayment = lazy(() => import("page/payment/bankInPayment"));
const PaymentDone = lazy(() => import("page/payment-status/paymentDone"));
const PaymentFail = lazy(() => import("page/payment-status/paymentFail"));
const UploadDone = lazy(() => import("page/payment-status/uploadDone"));
const ClientPortal = lazy(() => import("page/login/clientPortal"));
const Test1 = lazy(() => import("page/test/test1"));

function MainRoutes() {
  // const { login } = useSelector((state) => state);
  // const state = useSelector((state) => state);
  // console.log("redux state",state);
  // const { isLoading, showAsideMenu } = store.getState();
  // const [merchantEmail, setMerchantEmail] = useState()
  // const [campaignUid, setCampaignUid] = useState()
  // const user = store?.getState()

  const location = useLocation();

  //   useEffect(()=>{
  //     // ANCHOR get merchantEmail from url
  //     const merchantEmail = location.search.split("?")[1];
  //     // ANCHOR get campaignUid from url
  //     const campaignUid = location.search.split("?")[2];
  //     setCampaignUid(campaignUid)
  //     console.log("%ccampaignUid", "color:red",campaignUid);
  //     // !SECTION get info from url
  //     if (merchantEmail ) {
  //           (async () => {
  //           const res = await getMerchantByEmail(merchantEmail);
  //               setMerchantInfo(res?.data);
  //               console.log("res.data",res?.data);
  //           })();
  //       }
  // },[])

  const params = new URLSearchParams(window.location.search);
  const orderNumber = params.get("orderNumber");
  const validUrl = location.search.replace(/\+/g, '%20').replace("%3F", "?").split("fbclid")[0].split("&")[0]
  const [merchantEmail, setMerchantEmail] = useState(validUrl.split("?")[1])
  const [campaignUid, setCampaignUid] = useState(validUrl.split("?")[2])
  const [isUseSwitchMerchant, setIsUseSwitchMerchant] = useState(true)

  useEffect(()=>{
    if(!merchantEmail && location?.state?.merchantInfo)setMerchantEmail(location.state.merchantInfo.email)
    if(!campaignUid && location?.state?.campaignInfo)setCampaignUid( location.state.campaignInfo.uid)
    if(location?.state?.tranGot){
      console.log("setTranByRedux",setTranByRedux);
      setTranByRedux(location?.state?.tranGot)
    }
  },[location])
  
  const shops = [
    {
      merchantId: 5,
      path: "mothers-day",
      promotion: "Mother's Day",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAUld8NhgZ4eWXeMxnWCARW3GES_bUkv7CXA&usqp=CAU",
    },
    {
      merchantId: 1,
      path: "birthday",
      promotion: "Birthday",
      img: "https://img.myloview.com/stickers/birthday-sale-landing-page-template-individual-special-offer-online-shopping-banner-poster-invitation-flyer-vector-illustration-700-209522852.jpg",
    },
    // {merchantId: 130, path: "posh-nosh", promotion: "Posh Nosh", img: "https://img.shoplineapp.com/media/image_clips/6268ddd0cdbe18002114f1d7/original.png?1651039696"},
    // {merchantId: 133, path: "garden", promotion: "Garden", img: gardenLogo},
    {
      merchantId: 136,
      path: "nordic-naturals",
      promotion: "Nordic Naturals",
      img: "https://cdn.shopify.com/s/files/1/0557/6300/9723/files/nordic-naturals-logo-web_cbd90033-5e06-4d8e-a1e0-4b9979ee043f_390x.jpg?v=1649406301",
    },
  ];

  const [merchantInfo, setMerchantInfo] = useState();
  const [campaignInfo, setCampaignInfo] = useState();
  const [template, setTemplate] = useState();
  const [templateId, setTemplateId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [expired, setExpired] = useState(false);
  const [invalid , setInvalid]  = useState(false)


  const checkRole = async () => {
    setIsLoading(true)
    console.log('checking role...');

    auth.onAuthStateChanged(async function (data) {
      console.log('auth data', data);
      console.log("store.getState().user",store.getState().user);
      
      
      if (data) {
        if (!store.getState().user ) {
          console.log('get client', data.email);
          const client = await  getClientByEmail(data.email);
          console.log("getClientByEmail client",client);
          if (client) {
            await setUser("client", data.email);
            
    
            setIsLoading(false)
            console.log('role: m');
          }
          else {
            setIsLoading(false)
            console.log("no role");
          }
        }
      }
      else {
        // User is not signed in.
        setIsLoading(false)
        console.log("no role");
      }
    });
  };

  useEffect(() => {
    (async () => {
      await checkRole()
      if (!store.getState().currencies) {
        const { data: currencies } = await getCurrencies()
        if (currencies) setCurrencies(currencies);
      }
      const { domainInfo } = store.getState()
      console.log({domainInfo});
      console.log("domainInfo",domainInfo);
      if ((domainInfo.name === "www.hkposhnosh.com" ||
      domainInfo.name === "shop.dailon.com.hk") &&
      !campaignUid &&
      !merchantEmail) {
        setMerchantEmail(domainInfo.merchantEmail)
        setCampaignUid(domainInfo.merchantCampaignUid)
      } else setIsUseSwitchMerchant(false)
    })();
  }, [])
  
  console.log("orderNumber", orderNumber);
  console.log("merchantEmail",merchantEmail);
  console.log("campaignUid",campaignUid);
  useEffect(() => {
    if (merchantEmail && !orderNumber) {
      (async () => {
        const res = await getMerchantByEmail(merchantEmail);
        setMerchantInfo(res?.data);
        console.log("getMerchantByEmail res",res);
        // setMerchantInfoByRedux(res?.data)
      })();
    }
  }, [merchantEmail]);

  useEffect(() => {
      const fetchTemplate = async ({templateId,merchantId}) => {
      // setIsLoading(true);
      templateId = campaignUid === "moono" ? 60 : templateId
      console.log("templateId",templateId);

      const result = await getTemplate({templateId,merchantId});
      console.log("getTemplate result",result);
      // 找得到就用找得到的template
      if(result.data) {
        console.log(" setTemplate(result.data.template);",result.data.template);

        setTemplate(result.data.template);
        setTemplateByRedux(result.data.template)
      }
      // 不然就用預設的
      else {
          console.log(" setTemplate(default_white)",default_white);

          setTemplate(default_white)
          setTemplateByRedux(result.data.template)

        }
      // setIsLoading(false);
  }

    if (merchantInfo) {
      // 給予poshnosh hard code template
      console.log("merchantInfo",merchantInfo);
      if (campaignUid) {
        console.log(
          "%ccampaignUid",
          "color:cyan;",
          decodeURIComponent(campaignUid)
        );

        (async () => {
          const res = await campaignApi.getByUid(campaignUid, merchantInfo.id);

          const campaignFetched = res.data;
          console.log("%ccampaign", "color:cyan;", campaignFetched);
          const today = dayjs(Date.now());
          const campaignStartDate = dayjs(campaignFetched.startDate);
          const campaignEndDate = dayjs(campaignFetched.endDueDate);
          console.log("today", today);
          console.log("campaignStartDate", campaignStartDate);
          console.log("campaignEndDate", campaignEndDate);
          console.log(
            " campaignFetched.webstoreStatus === 1",
            campaignFetched.webstoreStatus === 1
          );
          console.log(
            " today.isAfter(campaignStartDate)",
            today.isAfter(campaignStartDate)
          );
          console.log(
            "today.isBefore(campaignEndDate) ",
            today.isBefore(campaignEndDate)
          );
          if(!campaignFetched){
            setInvalid(true)
          }
          if (
            // campaign status === 2 (Active)必須打開
            campaignFetched.statusId === 2 &&
            // campaign webstoreStatus === 1 必須打開
            campaignFetched.webstoreStatus === 1 &&
            // 如果是default就無需計算有效日期
            (
              campaignFetched.typeId === 0 ||
            // 當日必須晚於campaign起始日
            (
              today.isAfter(campaignStartDate) 
            // 當日必須早於campaign結束日
            &&  today.isBefore(campaignEndDate)
            )
            )
          ) {
            console.log("campaign fetched",res.data);

            setCampaignInfo(res.data);

            fetchTemplate({templateId:res.data.templateId,merchantId:merchantInfo.id})

          }
          // 否則，回歸到no campaign，預設merchant的template
          else {
            console.log("campaign fetched is null",res.data);
            setExpired(true)
          }
        })();
      } 
      else {

        fetchTemplate({merchantId:merchantInfo.id,campaignId:null})
        // setTemplateId(merchantInfo.templateId);
      }
    }

  }, [merchantInfo,campaignUid]);

  // useEffect(() => {
  //     const fetchTemplate = async ({merchantId,campaignId}) => {
  //       setIsLoading(true);
  //       const result = await getTemplate({merchantId,campaignId});

  //       setTemplate(result.data.template);
  //       setIsLoading(false);
  //     };
  //     console.log("campaign", campaign);
  //     if (campaign || merchantInfo) {
  //       fetchTemplate({merchantId:merchantInfo.id,campaignId:campaign.id})
  //     } 
  //   }
  // , [campaign,merchantInfo]);

  const [css, setCss] = useState();

 

  useEffect(() => {
    console.log("template", template);

    if (template?.styleId === 1) {
      import("page/webStore/css/red_white/red_white.module.scss").then((response) => {
        console.log("response", response);

        setCss( response.default)
        setStyles( response.default);
      });
    import("page/webStore/css/red_white/_calendar.scss");
    } else if (template?.styleId === 2) {
      import("page/webStore/css/poshNosh/poshNosh.module.scss").then(
        (response) => {
          console.log("response", response);
          setCss(response.default)
          setStyles(response.default);
        }
      );
      import("page/webStore/css/poshNosh/_calendar.scss");
    }
    else if (template?.styleId === 3) {
      import("page/webStore/css/blue_white/blue_white.module.scss").then(
        (response) => {
          console.log("response", response);
          setCss( response.default)
          setStyles( response.default);
        }
      );
      import("page/webStore/css/blue_white/_calendar.scss");
    }
    else if (template?.styleId === 4) {
      import("page/webStore/css/moono/moono.module.scss").then(
        (response) => {
          console.log("response", response);
          setCss( response.default)
          setStyles( response.default);
        }
      );
      import("page/webStore/css/moono/_calendar.scss");
    }
    else if (template?.styleId === 5) {
      import("page/webStore/css/dailonhk/dailonhk.module.scss").then(
        (response) => {
          console.log("response", response);
          setCss( response.default)
          setStyles( response.default);
        }
      );
      
      import("page/webStore/css/dailonhk/_calendar.scss");
    }
    else if (template?.styleId === 6) {
      import("page/webStore/css/temukan/temukan.module.scss").then(
        (response) => {
          console.log("response", response);
          setCss(response.default);
          setStyles(response.default);
        }
      );
      
      import("page/webStore/css/temukan/_calendar.scss");
    }
    
  }, [template]);

  const SwitchMerchant = () => {
    console.log("template",template);
    if (!template) return <Loading text="" />;
    switch (template?.typeId) {
      case 1:
        return null

      case 2:
        // return <div>hello</div>
        return (
          <Index
            merchantInfo={merchantInfo}
            campaignInfo={campaignInfo}
            template={template}
            styleModules={css}
          />
        );
    
        case 3:
          // return <div>hello</div>
          return (
            <Index
              merchantInfo={merchantInfo}
              campaignInfo={campaignInfo}
              template={template}
              styleModules={css}
            />
          );

      default:
        return (
          <div>
            <h1>Template.typeId is not found.</h1>
          </div>
        );
    }
  };

  
  const PublicRoutes = ({ setIsLoading }) => {
  
    // if(!merchantEmail) return <div
    //     className="loading d-flex align-items-center position-absolute "
    //     style={{ zIndex: 101 }}
    //   >

    //   <span className="text-bz">Merchant email is NOT found.</span>
    // </div>
    return (
      <Routes>
        <Route exact path={"/"} element={isUseSwitchMerchant ? <SwitchMerchant /> : <ClientPortal />} />
        <Route exact path={"/barcode"} element={<TestBarcode />} />
        <Route exact path={"/scanner"} element={<FpsScanner />} />
        <Route exact path={"/render"} element={<HtmlRender />} />
        <Route exact path={"/remote"}
          element={<Transaction setIsLoading={setIsLoading} orderNumber={orderNumber} />}
        />
        <Route exact path={"/feedback"}
          element={<Feedback setIsLoading={setIsLoading} orderNumber={orderNumber} />}
        />
        <Route exact path={"/quote"}
          element={<Quotation setIsLoading={setIsLoading} orderNumber={orderNumber} />}
        />
        <Route exact path={"/_c"} element={<SwitchMerchant />} />
        <Route exact path={"/login"} element={<Login />} />
        <Route exact path={"/reset-password"} element={<ResetPassword />} />
        <Route
          exact
          path={"/payment-success"}
          element={<PaymentSuccessful />}
        />
        <Route exact path={"/print"} element={<PrintReceipt />} />

        {/* <Route exact path={"/order3"} element={<Navigate to="/login" replace />} /> */}
        <Route
          exact
          path={"/stripe-success"}
          element={<LoginPaymentSucess />}
        />
        {/* <Route exact path={"/garden-btob"} element={<Navigate to="/login" replace />} /> */}
        <Route
          exact
          path={"/landing-page"}
          element={<LandingPage shops={shops} />}
        />
        {/* posh nosh web store */}
        <Route exact path={"/stripe"} element={<StripePayment />} />
        <Route exact path={"/visa"} element={<VisaPayment />} />
        <Route exact path={"/mastercard"} element={<MastercardPayment />} />
        <Route exact path={"/fps"} element={<FpsBankInPayment />} />
        <Route exact path={"/fps-sbp"} element={<FpsAcquirerDynamicPayment />} />
        <Route exact path={"/bank-in"} element={<FpsBankInPayment />} />
        <Route exact path={"/payment-done"} element={<PaymentDone />} />
        <Route exact path={"/payment-fail"} element={<PaymentFail />} />
        <Route exact path={"/upload-done"} element={<UploadDone />} />
        <Route
          exact
          path={"/login"}
          element={<Navigate to="/order3" replace />}
        />
        <Route exact path={"/upload-done"} element={<UploadDone />} />
        <Route exact path={"/barcode"} element={<TestBarcode />} />
        <Route exact path={"/test"} element={<Test1 />} />

      </Routes>
    );
  };

  // const PrivateRoutes = () => {
  //   return (
  //     <Routes>
  //       <Route exact path={"/"} element={<Transaction />} />
  //       <Route exact path={"/barcode"} element={<TestBarcode />} />

  //       <Route exact path={"/payment-success"} element={<PaymentSuccessful />} />
  //       <Route exact path={"/new-order/print"} element={<NewOrderPrint />} />

  //       <Route
  //         exact
  //         path={"/stripe-success"}
  //         element={<LoginPaymentSucess />}
  //       />
  //       <Route exact path={"/order3/print"} element={<Print />} />
  //       <Route
  //         exact
  //         path={"/login"}
  //         element={<Navigate to="/order3" replace />}
  //       />
  //       <Route exact path={"/payment-done"} element={<PaymentDone />} />

  //       <Route exact path={"/fps"} element={<FpsPayment />} />
  //       <Route exact path={"/bank-in"} element={<BankInPayment />} />
  //       <Route exact path={"/payment-done"} element={<PaymentDone />} />
  //       <Route exact path={"/payment-fail"} element={<PaymentFail />} />
  //       <Route exact path={"/upload-done"} element={<UploadDone />} />
  //     </Routes>
  //   );
  // }

  // if(!template) return  null;


  if(invalid || expired) return(
    <div
    className="m-2 app-router-container h-100 position-relative "
    >
     <h1> The link is expired or invalid.</h1>
    
  </div>
    )



  return (
    <div
      className="app-router-container h-100 position-relative"
      // style={showAsideMenu ? { filter: "blur(2px)" } : null}
    >

      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="*" element={<PublicRoutes />} />

          {/* <Route exact path={"/"} element={<Transaction />} />
          <Route exact path={"/login"} element={<Login />} />
          <Route exact path={"/order3"} element={<Order3 merchantInfo={merchantInfo}/>} />
          <Route exact path={"/garden-btob"} element={<Order2 merchantInfo={merchantInfo} />} />
          <Route exact path={"/landing-page"} element={<LandingPage shops={shops} />} />
          <Route path={"landing-page/:promotion"} element={<Order />}/>
          <Route exact path={"/order"} element={<Order />} />
          <Route exact path={"/checkout"} element={<Checkout />} />
          <Route exact path={"/stripe"} element={<StripePayment />} />
          <Route exact path={"/visa"} element={<VisaPayment />} />
          <Route exact path={"/mastercard"} element={<MastercardPayment />} />
          <Route exact path={"/fps"} element={<FpsPayment />} />
          <Route exact path={"/payment-done"} element={<PaymentDone />} />
          <Route exact path={"/payment-fail"} element={<PaymentFail />} />
          <Route exact path={"/upload-done"} element={<UploadDone />} /> */}
        </Routes>
      </Suspense>
      {isLoading && <Loading  />}
    </div>
  );
}

export { MainRoutes };
